"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _colors = require("@material-ui/core/colors");
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _Typography = _interopRequireDefault(require("../Typography/Typography"));
var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));
var _excluded = ["className", "dataMetrics", "icon", "label", "status", "style", "variant", "width"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = function useStyles(_ref) {
  var icon = _ref.icon;
  return (0, _styles.makeStyles)(function (theme) {
    return {
      icon: {
        height: 12,
        marginRight: theme.spacing(0.5),
        width: 12
      },
      lightDefault: {
        backgroundColor: theme.palette.grey[100],
        border: "1px solid ".concat((0, _styles.alpha)(theme.palette.grey[700], 0.16)),
        color: theme.palette.text.secondary
      },
      lightError: {
        backgroundColor: theme.palette.error.light,
        border: "1px solid ".concat((0, _styles.alpha)(theme.palette.error.dark, 0.16)),
        color: theme.palette.error.dark
      },
      lightOk: {
        backgroundColor: theme.palette.accent.greenLight,
        border: "1px solid ".concat((0, _styles.alpha)(theme.palette.accent.greenDark, 0.16)),
        color: theme.palette.accent.greenDark
      },
      lightPrimary: {
        backgroundColor: '#F0FAFE',
        border: "1px solid ".concat((0, _styles.alpha)(theme.palette.primary.main, 0.16)),
        color: theme.palette.primary.main
      },
      lightSecondary: {
        backgroundColor: theme.palette.secondary[50],
        border: "1px solid ".concat((0, _styles.alpha)(theme.palette.secondary.main, 0.16)),
        color: theme.palette.secondary.main
      },
      lightWarning: {
        backgroundColor: theme.palette.accent.orangeLight,
        border: "1px solid ".concat((0, _styles.alpha)(theme.palette.accent.orangeDark, 0.16)),
        color: theme.palette.accent.orangeDark
      },
      outlined: {
        backgroundColor: 'transparent'
      },
      outlinedDefault: {
        border: "1px solid ".concat(theme.palette.opacity.black[60]),
        color: theme.palette.opacity.black[60]
      },
      outlinedError: {
        border: "1px solid ".concat(theme.palette.accent.redMain),
        color: theme.palette.accent.redMain
      },
      outlinedOk: {
        border: "1px solid ".concat(theme.palette.accent.greenMain),
        color: theme.palette.accent.greenMain
      },
      outlinedPrimary: {
        border: "1px solid ".concat(theme.palette.primary[800]),
        color: theme.palette.primary[800]
      },
      outlinedSecondary: {
        border: "1px solid ".concat(theme.palette.secondary[800]),
        color: theme.palette.secondary[800]
      },
      outlinedWarning: {
        border: "1px solid ".concat(theme.palette.accent.orangeMain),
        color: theme.palette.accent.orangeMain
      },
      root: {
        alignItems: 'center',
        borderRadius: theme.shape.borderRadius,
        display: 'inline-flex',
        height: '16px',
        justifyContent: 'center',
        minWidth: "".concat(icon ? '31px' : '22px'),
        padding: '0px 4px'
      },
      solid: {
        color: _colors.common.white
      },
      solidDefault: {
        backgroundColor: theme.palette.opacity.black[60]
      },
      solidError: {
        backgroundColor: theme.palette.accent.redMain
      },
      solidOk: {
        backgroundColor: theme.palette.accent.greenMain
      },
      solidPrimary: {
        backgroundColor: theme.palette.primary[800]
      },
      solidSecondary: {
        backgroundColor: theme.palette.secondary[800]
      },
      solidWarning: {
        backgroundColor: theme.palette.accent.orangeMain
      },
      textRoot: {
        color: 'inherit',
        display: 'inline-block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    };
  })();
};
var defaultProps = {
  dataMetrics: {
    root: 'fuse_badge'
  },
  status: 'default',
  variant: 'solid'
};

/**
 * Badges are used to indicate support content like section counts, volume of malicious content, etc.
 * Badges are static, usually not clickable.
 */
var Badge = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var _cx;
  var className = _ref2.className,
    dataMetrics = _ref2.dataMetrics,
    icon = _ref2.icon,
    label = _ref2.label,
    status = _ref2.status,
    style = _ref2.style,
    variant = _ref2.variant,
    width = _ref2.width,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var classes = useStyles({
    icon: icon
  });
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    isOverflowing = _React$useState2[0],
    setIsOverflowing = _React$useState2[1];
  var textRef = _react["default"].useRef(null);
  var resetTooltip = _react["default"].useCallback(function () {
    if (textRef && textRef.current && textRef.current.scrollWidth > textRef.current.offsetWidth) {
      setIsOverflowing(true);
    } else {
      setIsOverflowing(false);
    }
  }, []);
  _react["default"].useLayoutEffect(function () {
    resetTooltip();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width, label]); // for storybook control

  _react["default"].useEffect(function () {
    var debouncedResetTooltip = (0, _lodash.debounce)(resetTooltip, 100);
    window.addEventListener('resize', debouncedResetTooltip);
    return function () {
      return window.removeEventListener('resize', debouncedResetTooltip);
    };
  }, [resetTooltip]);
  var iconComponent = icon ? /*#__PURE__*/_react["default"].cloneElement(icon, {
    className: (0, _classnames["default"])(classes.icon, icon.props.className)
  }) : null;
  var text = /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])(className, classes.root, (_cx = {}, (0, _defineProperty2["default"])(_cx, classes.outlined, variant === 'outlined'), (0, _defineProperty2["default"])(_cx, classes.outlinedDefault, variant === 'outlined' && status === 'default'), (0, _defineProperty2["default"])(_cx, classes.outlinedPrimary, variant === 'outlined' && status === 'primary'), (0, _defineProperty2["default"])(_cx, classes.outlinedSecondary, variant === 'outlined' && status === 'secondary'), (0, _defineProperty2["default"])(_cx, classes.outlinedError, variant === 'outlined' && status === 'error'), (0, _defineProperty2["default"])(_cx, classes.outlinedOk, variant === 'outlined' && status === 'ok'), (0, _defineProperty2["default"])(_cx, classes.outlinedWarning, variant === 'outlined' && status === 'warning'), (0, _defineProperty2["default"])(_cx, classes.solid, variant === 'solid'), (0, _defineProperty2["default"])(_cx, classes.solidDefault, variant === 'solid' && status === 'default'), (0, _defineProperty2["default"])(_cx, classes.solidPrimary, variant === 'solid' && status === 'primary'), (0, _defineProperty2["default"])(_cx, classes.solidSecondary, variant === 'solid' && status === 'secondary'), (0, _defineProperty2["default"])(_cx, classes.solidError, variant === 'solid' && status === 'error'), (0, _defineProperty2["default"])(_cx, classes.solidOk, variant === 'solid' && status === 'ok'), (0, _defineProperty2["default"])(_cx, classes.solidWarning, variant === 'solid' && status === 'warning'), (0, _defineProperty2["default"])(_cx, classes.lightDefault, variant === 'light' && status === 'default'), (0, _defineProperty2["default"])(_cx, classes.lightPrimary, variant === 'light' && status === 'primary'), (0, _defineProperty2["default"])(_cx, classes.lightSecondary, variant === 'light' && status === 'secondary'), (0, _defineProperty2["default"])(_cx, classes.lightError, variant === 'light' && status === 'error'), (0, _defineProperty2["default"])(_cx, classes.lightOk, variant === 'light' && status === 'ok'), (0, _defineProperty2["default"])(_cx, classes.lightWarning, variant === 'light' && status === 'warning'), _cx)),
    "data-metrics": mergedDataMetrics.root,
    ref: ref,
    style: _objectSpread({
      width: width
    }, style) // width value in style can be any format, like 100%, 40vw, should not be overriden by width: undefined
  }, props), iconComponent, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: classes.textRoot,
    ref: textRef,
    variant: "overline"
  }, label));
  return isOverflowing ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: label
  }, text) : text;
});
Badge.defaultProps = defaultProps;
Badge.displayName = 'Badge';
Badge.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * Optional icon to render within the badge,
   */
  icon: _propTypes["default"].element,
  /**
   * The label content.
   */
  label: _propTypes["default"].string,
  /**
   * The style of the component.
   */
  status: _propTypes["default"].oneOf(['default', 'error', 'ok', 'primary', 'secondary', 'warning']),
  /**
   * @ignore
   */
  style: _propTypes["default"].object,
  /**
   * The variant to use.
   */
  variant: _propTypes["default"].oneOf(['solid', 'outlined', 'light']),
  /**
   * Manually set the width of the badge
   */
  width: _propTypes["default"].number
} : {};
var _default = Badge;
exports["default"] = _default;